
import DeliveryArea from '~/pages/_lang/delivery-area/_id/_province/_zip.vue'

export default DeliveryArea
